import { action, computed, makeObservable } from 'mobx';
import React from 'react';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {InlineOpenEndedQuestionModel} from '../models';
import {OpenEndedQuestionState, setInputValue, InputState, InputStates} from './models';

export class OpenEndedQuestionStore {
  constructor(readonly id: number,
              readonly model: InlineOpenEndedQuestionModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
  }

  @computed
  get openEndedQuestionState(): OpenEndedQuestionState {
    const states: {[index: string]: InputState} = {} as InputStates;
    const altOpenEndedQuestionState: OpenEndedQuestionState = { states };

    this.model.paragraphs.map((value, key) => {
      value.items.map((v, k) => {
        Object.assign(altOpenEndedQuestionState.states, {[`${key}/${k}`]: {value: ''}})
      })
    });

    return this.stateStore.getContentState<OpenEndedQuestionState>(this.id) ? this.stateStore.getContentState<OpenEndedQuestionState>(this.id)! : altOpenEndedQuestionState;
  }

  @action
  changeHandler(inputId: string, event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setChange(inputId, value)
  }

  @action
  private setChange(inputId: string, value: string) {
    this.updateState(setInputValue(this.openEndedQuestionState, inputId, value));
  }

  @action
  private updateState(state: OpenEndedQuestionState) {
    this.stateStore.setContentState(this.id, state);
  }
}
